import i18n from 'helpers/i18n';
import messages from './messages';
import lampIcon from 'images/reliabilityTest/lampIcon.svg';
import { Text } from '@teachstonellc/component-library';

function KnowledgeTestInstructionsContent() {
  return (
    <div>
      <ul className="list-disc ms-6 marker:text-orange-400 text-3xl">
        <li className="mb-4">
          <div className="flex items-start ms-4 text-lg">
            {i18n.ft(messages.attempts)}
          </div>
        </li>
        <li className="mb-4">
          <div className="flex items-start ms-4 text-lg">
            {i18n.ft(messages.pass)}
          </div>
        </li>
        <li className="mb-4">
          <div className="flex items-start ms-4 text-lg">
            {i18n.ft(messages.fail)}
          </div>
        </li>
        <li className="mb-4">
          <div className="flex items-start ms-4 text-lg">
            {i18n.ft(messages.complete)}
          </div>
        </li>
        <li className="mb-4">
          <div className="flex items-start ms-4 text-lg">
            {i18n.ft(messages.provide)}
          </div>
        </li>
      </ul>
      <Text as="h3" className="py-4">
        {i18n.ft(messages.recommendations)}
      </Text>
      <ul className="mb-5">
        <li className="mb-4">
          <div className="flex items-start text-lg">
            <img src={lampIcon} className="inline mr-4" alt="" />
            {i18n.ft(messages.test)}
          </div>
        </li>
        <li className="mb-4">
          <div className="flex items-start text-lg">
            <img src={lampIcon} className="inline mr-4" alt="" />
            {i18n.ft(messages.unsuccessful)}
          </div>
        </li>
      </ul>
    </div>
  );
}

export default KnowledgeTestInstructionsContent;
